var _rect, _rect2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwibecoSquareRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#006CFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 25,
    height: 25,
    rx: 5,
    fill: "#006CFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 12.5,
    r: 9.625,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.063 13.936a8.977 8.977 0 0 1-.857-.175c-.49-.138-1.164-.298-1.81-.5l-1.23-.442a.32.32 0 0 1-.162-.148c-.07-.16.014-.34.189-.407l1.202-.434c.647-.202 1.317-.362 1.811-.5.281-.072.57-.131.857-.176.774-.108 1.303-.767 1.186-1.467-.12-.7-.848-1.179-1.623-1.073-.349.05-.668.217-.889.464a7 7 0 0 1-.595.582c-.379.32-.87.767-1.382 1.171l-1.053.75a.32.32 0 0 1-.169.057c-.185 0-.338-.136-.34-.306l.195-1.22c.134-.608.314-1.217.429-1.668.07-.257.16-.508.262-.757.283-.664-.082-1.406-.81-1.663-.734-.256-1.555.074-1.839.733a1.16 1.16 0 0 0 0 .925c.101.249.191.503.262.757.115.456.295 1.06.428 1.667.069.415.134.822.194 1.187a.242.242 0 0 1-.046.167c-.104.143-.317.18-.478.087-.013-.005-.03-.013-.043-.013l-.996-.71c-.513-.405-1.006-.848-1.382-1.17a8.898 8.898 0 0 1-.595-.581c-.49-.553-1.385-.639-1.999-.195-.614.444-.706 1.253-.215 1.808.223.249.54.414.889.463.289.045.575.104.856.176.49.138 1.165.298 1.81.5l1.217.437c.066.024.12.064.158.12.088.151.02.341-.147.418-.01.004-.016.012-.022.02l-1.2.43c-.646.203-1.317.363-1.81.502-.282.071-.57.13-.857.175-.774.108-1.304.77-1.18 1.47.12.7.85 1.178 1.625 1.067.346-.049.66-.212.88-.458.186-.205.385-.4.595-.582.38-.316.87-.762 1.383-1.17l1.072-.764a.312.312 0 0 1 .177-.04c.19.018.327.168.308.34v.01l-.19 1.172c-.135.607-.315 1.216-.43 1.668a6.96 6.96 0 0 1-.26.757c-.285.663.08 1.405.809 1.662.734.256 1.555-.074 1.838-.733a1.16 1.16 0 0 0 0-.924c-.1-.25-.19-.504-.262-.758-.114-.456-.294-1.06-.428-1.667-.068-.436-.142-.873-.202-1.25 0-.032.011-.062.022-.091.082-.153.29-.22.458-.146h.006l1.082.772c.513.404 1.007.848 1.383 1.169.21.188.41.382.595.582.49.552 1.385.639 1.999.195.613-.444.706-1.253.215-1.808a1.492 1.492 0 0 0-.892-.464Z",
    fill: "#006CFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.25 5.938)",
    d: "M0 0h13.019v13.209H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.25 5.938)",
    d: "M0 0h13.019v13.209H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.875,
    y: 0.875,
    width: 25.25,
    height: 25.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12215_4056"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12215_4056",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwibecoSquareRounded);
export default __webpack_public_path__ + "static/media/swibeco_square_rounded.9fd98ef8c92304130e33df8ce4561e56.svg";
export { ForwardRef as ReactComponent };